<template>
  <div class="container-fluid mt-5">
    <!-- Header Section -->
    <div class="d-flex flex-column flex-sm-row justify-content-sm-between">
      <div>
        <div>
          <div class="text-head font-weight-bold h2 py-0 my-0 text-black">
            All Assets
          </div>
          <BackRoute />
        </div>
        <!-- <div class="d-flex align-items-center w-100 cursor-pointer">
          <span class="mr-1 text-white">
            <VideoPlayIcon />
          </span>
          <span class="s-13 text-dak font-weight-600">
            <u>
              {{
                navigatorLang === "en-US"
                  ? "Watch Video"
                  : $t("people.watchVideo")
              }}
            </u>
          </span>
        </div> -->
      </div>
      <div class="d-flex flex-wrap flex-sm-nowrap mt-3 mt-sm-0">
        <el-dropdown
          trigger="click"
          class="align-items-center w-100 justify-content-center d-flex ml-md-3 ml-0 default-btn2 py-0 m-0 border"
          style="height: 2.2rem"
        >
          <span
            class="el-dropdown-link w-100 primary--text d-flex align-items-center justify-content-center text-center font-weight-600"
          >
            <span>{{
              navigatorLang === "en-US" ? "More" : $t("people.more")
            }}</span>
            <el-icon class="el-icon--right">
              <arrow-down />
            </el-icon>
          </span>
          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item class="text-dak">
                <router-link
                  :to="`/tenant/asset/assetissues`"
                  class="no-decoration text-dak"
                >
                  Issues
                </router-link>
              </el-dropdown-item>
              <el-dropdown-item class="text-dak">
                <router-link
                  :to="`/tenant/asset/assetrequests`"
                  class="no-decoration text-dak"
                >
                  Requests
                </router-link>
              </el-dropdown-item>
              <el-dropdown-item class="text-dak">
                <router-link
                  :to="`/tenant/asset/assetmaintenancehistory`"
                  class="no-decoration text-dak"
                >
                  Maintenance
                </router-link>
              </el-dropdown-item>

              <el-dropdown-item class="text-dak">
                <router-link
                  :to="`/tenant/asset/assetcategories`"
                  class="no-decoration text-dak"
                >
                  Categories
                </router-link>
              </el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
        <router-link :to="`/tenant/asset/create`" class="no-decoration w-100">
          <el-button
            :color="primarycolor"
            class="ml-0 ml-sm-2 mt-sm-0 mt-3 w-100 header-btn"
            round
          >
            Add New Asset
          </el-button>
        </router-link>
      </div>
    </div>

    <!-- Table Section -->
    <div class="row mt-5">
      <div class="container-fluid px-0">
        <div class="col-md-12" v-loading="loading">
          <div v-if="filteredData.length > 0">
            <TableNoExport2
              :data="filteredData"
              :headers="AssetHeaders"
              @showfilter="handleFilter"
              @update:searchText="handleSearchTextUpdate"
              :checkMultipleItem="false"
              :filterItem="true"
            >
              <template v-slot:assetCode="{ item }">
                <div class="c-pointer fw-400" @click="showAssetOverview(item)">
                  {{ item.assetCode }}
                </div>
              </template>

              <template v-slot:name="{ item }">
                <div class="c-pointer fw-400" @click="showAssetOverview(item)">
                  {{ item.name }}
                </div>
              </template>
              <template v-slot:category="{ item }">
                <div class="c-pointer fw-400" @click="showAssetOverview(item)">
                  {{ item.category?.name }}
                </div>
              </template>
              <!-- <template v-slot:assigned="{ item }">
                  <div
                    class="c-pointer fw-400 s-12"
                    @click="showAssetInfo(item)"
                  >
                    {{ item.assigned }}
                  </div>
                </template> -->
              <template v-slot:status="{ item }">
                <div class="c-pointer fw-400" @click="showAssetOverview(item)">
                  {{ statusOptions[item.status] }}
                </div>
              </template>
              <template v-slot:dateOfPurchase="{ item }">
                <div class="c-pointer fw-400" @click="showAssetOverview(item)">
                  {{ date(item.dateOfPurchase) }}
                </div>
              </template>
              <template v-slot:action="{ item }">
                <el-dropdown trigger="click">
                  <el-icon>
                    <MoreFilled />
                  </el-icon>
                  <template #dropdown>
                    <el-dropdown-menu>
                      <el-dropdown-item
                        @click.prevent="showConfirmModal(item.id, index)"
                      >
                        <div class="text-color">Delete</div>
                      </el-dropdown-item>
                      <el-dropdown-item @click.prevent="showAssetInfo(item)">
                        <div class="text-color">Edit</div>
                      </el-dropdown-item>
                      <el-dropdown-item
                        @click.prevent="showAssetOverview(item)"
                      >
                        <div class="text-color">Overview</div>
                      </el-dropdown-item>
                    </el-dropdown-menu>
                  </template>
                </el-dropdown>
              </template>
            </TableNoExport2>
          </div>
          <div v-else class="text-center py-5">
            <el-empty description="No Asset records available" />
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      v-model="showFilter"
      :title="null"
      :width="mdAndUp || lgAndUp || xlAndUp ? '60%' : '90%'"
      class="border-radius-8"
      :show-close="false"
    >
      <div class="px-4">
        <div class="d-flex justify-content-between align-items-center mb-4">
          <div class="d-flex align-items-center">
            <span class="mr-3"
              ><FunnelSampleIcon class="w-18 h-18 text-dak"
            /></span>
            <div class="font-weight-600 s-24 text-dak">Filter Asset</div>
          </div>

          <el-button link class="text-dak" @click="showFilter = false">
            <el-icon :size="18" class="el-icon--right"><close /></el-icon>
          </el-button>
        </div>

        <div class="filter-container">
          <div class="row">
            <div class="col-md-6">
              <!-- Core Information Section -->
              <div class="section mb-4">
                <h6 class="section-title mb-4">Core Information</h6>

                <div class="row mb-3 align-items-center">
                  <div class="col-md-4 text-md-right text-left">
                    <label class="fw-500 s-12 text-head text-dak"
                      >Asset Name</label
                    >
                  </div>
                  <div class="col-md-8">
                    <el-input
                      v-model="form.assetName"
                      placeholder="Enter asset name"
                      size="medium"
                      class="w-100"
                    />
                  </div>
                </div>

                <div class="row mb-3 align-items-center">
                  <div class="col-md-4 text-md-right text-left">
                    <label class="fw-500 s-12 text-head text-dak"
                      >Category</label
                    >
                  </div>
                  <div class="col-md-8">
                    <el-select
                      v-model="form.category"
                      placeholder="Select"
                      size="medium"
                      class="w-100"
                    >
                      <el-option label="Sound" value="sound" />
                      <el-option label="Video" value="video" />
                      <el-option label="IT Equipment" value="it" />
                    </el-select>
                  </div>
                </div>

                <div class="row mb-3 align-items-center">
                  <div class="col-md-4 text-md-right text-left">
                    <label class="fw-500 s-12 text-head text-dak"
                      >Serial No.</label
                    >
                  </div>
                  <div class="col-md-8">
                    <el-input
                      v-model="form.serialNo"
                      placeholder="Enter serial number"
                      size="medium"
                      class="w-100"
                    />
                  </div>
                </div>

                <div class="row mb-3 align-items-center">
                  <div class="col-md-4 text-md-right text-left">
                    <label class="fw-500 s-12 text-head text-dak"
                      >Manufacturer</label
                    >
                  </div>
                  <div class="col-md-8">
                    <el-input
                      v-model="form.manufacturer"
                      placeholder="Enter manufacturer"
                      size="medium"
                      class="w-100"
                    />
                  </div>
                </div>

                <div class="row mb-3 align-items-center">
                  <div class="col-md-4 text-md-right text-left">
                    <label class="fw-500 s-12 text-head text-dak"
                      >Model/Version</label
                    >
                  </div>
                  <div class="col-md-8">
                    <el-input
                      v-model="form.modelVersion"
                      placeholder="Enter model/version"
                      size="medium"
                      class="w-100"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <!-- Others Section -->
              <div class="section mb-4">
                <h6 class="section-title mb-4">Others</h6>

                <div class="row mb-3 align-items-center">
                  <div class="col-md-4 text-md-right text-left">
                    <label class="fw-500 s-12 text-head text-dak"
                      >Physical Location</label
                    >
                  </div>
                  <div class="col-md-8">
                    <el-input
                      v-model="form.location"
                      placeholder="Enter location"
                      size="medium"
                      class="w-100"
                    />
                  </div>
                </div>

                <div class="row mb-3 align-items-center">
                  <div class="col-md-4 text-md-right text-left">
                    <label class="fw-500 s-12 text-head text-dak"
                      >Assigned to</label
                    >
                  </div>
                  <div class="col-md-8">
                    <el-select
                      v-model="form.assignedTo"
                      placeholder="Select"
                      size="medium"
                      class="w-100"
                    >
                      <el-option label="Media Department" value="media" />
                      <el-option label="IT Department" value="it" />
                      <el-option label="HR Department" value="hr" />
                    </el-select>
                  </div>
                </div>

                <div class="row mb-3 align-items-center">
                  <div class="col-md-4 text-md-right text-left">
                    <label class="fw-500 s-12 text-head text-dak">Status</label>
                  </div>
                  <div class="col-md-8">
                    <el-select
                      v-model="form.status"
                      placeholder="Select"
                      size="medium"
                      class="w-100"
                    >
                      <el-option label="In-Use" value="in-use" />
                      <el-option label="Available" value="available" />
                      <el-option label="Maintenance" value="maintenance" />
                    </el-select>
                  </div>
                </div>

                <div class="row mb-3 align-items-center">
                  <div class="col-md-4 text-md-right text-left">
                    <label class="fw-500 s-12 text-head text-dak"
                      >Condition</label
                    >
                  </div>
                  <div class="col-md-8">
                    <el-select
                      v-model="form.condition"
                      placeholder="Select"
                      size="medium"
                      class="w-100"
                    >
                      <el-option label="New" value="new" />
                      <el-option label="Good" value="good" />
                      <el-option label="Fair" value="fair" />
                      <el-option label="Poor" value="poor" />
                    </el-select>
                  </div>
                </div>

                <div class="row mb-3 align-items-center">
                  <div class="col-md-4 text-md-right text-left">
                    <label class="fw-500 s-12 text-head text-dak"
                      >Maintenance</label
                    >
                  </div>
                  <div class="col-md-8">
                    <el-select
                      v-model="form.maintenance"
                      placeholder="Select"
                      size="medium"
                      class="w-100"
                    >
                      <el-option label="Monthly" value="monthly" />
                      <el-option label="Quarterly" value="quarterly" />
                      <el-option label="Yearly" value="yearly" />
                    </el-select>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row align-items-end">
            <div class="col-md-6">
              <!-- Financial Details Section -->
              <div class="section mb-4">
                <h6 class="section-title mb-4">Financial details</h6>

                <div class="row mb-3 align-items-center">
                  <div class="col-md-4 text-md-right text-left">
                    <label class="fw-500 s-12 text-head text-dak"
                      >Purchase Date</label
                    >
                  </div>
                  <div class="col-md-8">
                    <el-date-picker
                      v-model="form.amount"
                      type="date"
                      placeholder="Select date"
                      size="large"
                      class="w-100"
                    />
                  </div>
                </div>

                <div class="row mb-3 align-items-center">
                  <div class="col-md-4 text-md-right text-left">
                    <label class="fw-500 s-12 text-head text-dak"
                      >Purchase Price</label
                    >
                  </div>
                  <div class="col-md-8">
                    <el-input
                      v-model="form.dateOfPurchase"
                      placeholder="Enter purchase price"
                      size="medium"
                      class="w-100"
                    />
                  </div>
                </div>

                <div class="row mb-3 align-items-center">
                  <div class="col-md-4 text-md-right text-left">
                    <label class="fw-500 s-12 text-head text-dak"
                      >Warranty</label
                    >
                  </div>
                  <div class="col-md-8">
                    <el-input
                      v-model="form.warranty"
                      placeholder="Enter warranty period"
                      size="medium"
                      class="w-100"
                    />
                  </div>
                </div>

                <div class="row mb-3 align-items-center">
                  <div class="col-md-4 text-md-right text-left">
                    <label class="fw-500 s-12 text-head text-dak"
                      >Depreciation %</label
                    >
                  </div>
                  <div class="col-md-8">
                    <el-input
                      v-model="form.depreciationRate"
                      placeholder="Enter depreciation percentage"
                      size="medium"
                      class="w-100"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6 mt-4">
              <div class="row justify-content-center">
                <div class="col-md-10">
                  <el-button
                    round
                    :color="primarycolor"
                    class="text-white w-100 py-4"
                    size="large"
                    @click="handleApply"
                  >
                    Apply & Search
                  </el-button>
                </div>
              </div>

              <div class="row justify-content-center">
                <div class="col-md-10">
                  <div class="mt-3">
                    <el-button
                      link
                      class="reset-btn w-100 text-dak"
                      @click="resetForm"
                    >
                      Reset Filter
                    </el-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, inject } from "vue";
import FunnelSampleIcon from "../../../components/icons/FunnelSampleIcon.vue";
import BackRoute from "../../../components/backroute/BackRoute.vue";
import TableNoExport2 from "../../../components/table/TableNoExport2.vue";
import deviceBreakpoint from "../../../mixins/deviceBreakpoint";
import { ElNotification, ElMessageBox } from "element-plus";
import assetService from "../../../services/asset/assetServices";
import monthDayYear from "../../../services/dates/dateformatter";
import VideoPlayIcon from "../../../components/svg/VideoPlayIcon.vue";
import router from "../../../router/index";

const primarycolor = inject("primarycolor");
const navigatorLang = ref(navigator.language);
const searchText = ref("");
const loading = ref(false);
const assets = ref([]);
const showFilter = ref(false);
const { mdAndUp, lgAndUp, xlAndUp, xsOnly } = deviceBreakpoint();
const statusOptions = ref([
  "Available",
  "In Use",
  "Under Maintenance",
  "Retired",
]);
const AssetHeaders = ref([
  { name: "CODE", value: "assetCode" },
  { name: "NAME", value: "name" },
  { name: "CATEGORY", value: "category" },
  { name: "STATUS", value: "status" },
  { name: "PURCHASED DATE", value: "dateOfPurchase" },
  { name: "ACTION", value: "action" },
]);

const form = ref({
  name: "",
  category: "",
  serialNo: "",
  manufacturer: "",
  modelVersion: "",
  location: "",
  assignedTo: "",
  status: "",
  condition: "",
  maintenance: "",
  dateOfPurchase: "",
  amount: "",
  warranty: "",
  depreciationRate: "",
});

const resetForm = () => {
  form.value = {
    name: "",
    category: "",
    serialNo: "",
    manufacturer: "",
    modelVersion: "",
    location: "",
    assignedTo: "",
    status: "",
    condition: "",
    maintenance: "",
    dateOfPurchase: "",
    amount: "",
    warranty: "",
    depreciationRate: "",
  };
  console.log("Form reset");
};

const loadAssets = async () => {
  loading.value = true;
  try {
    const response = await assetService.getAssets();
    assets.value = response; // Adjust mapping if backend structure differs
    loading.value = false;
  } catch (error) {
    console.error("Error fetching assets:", error);
    loading.value = false;
  }
};
loadAssets();

const handleSearchTextUpdate = (newValue) => {
  searchText.value = newValue;
};

const filteredData = computed(() => {
  if (!searchText.value.trim()) {
    return assets.value;
  }
  return assets.value.filter((item) =>
    Object.values(item)
      .join(" ")
      .toLowerCase()
      .includes(searchText.value.toLowerCase())
  );
});

const showConfirmModal = (id, index) => {
  ElMessageBox.confirm(
    "Are you sure you want to delete this asset?",
    "Confirm delete",
    {
      confirmButtonText: "OK",
      cancelButtonText: "Cancel",
      type: "error",
    }
  )
    .then(() => {
      handleDeleteAsset(id);
    })
    .catch(() => {
      ElNotification({
        type: "info",
        message: "Delete canceled",
        duration: 5000,
      });
    });
};

const handleDeleteAsset = (id) => {
  assetService
    .deleteAsset(id)
    .then(() => {
      ElNotification({
        type: "success",
        message: "Asset deleted successfully",
        duration: 5000,
      });

      // Update asset list
      assets.value = assets.value.filter((asset) => asset.id !== id);
    })
    .catch((err) => {
      console.error(err);
      ElNotification({
        type: "error",
        message: "Unable to delete asset",
        duration: 5000,
      });
    });
};
const date = (offDate) => {
  return monthDayYear.monthDayYear(offDate);
};
const showAssetOverview = (item) => {
  router.push(`/tenant/asset/overview?id=${item.id}`);
};

const showAssetInfo = (item) => {
  router.push(`/tenant/asset/create?id=${item.id}`);
};
const handleFilter = (item) => {
  showFilter.value = item;
};
</script>
